// extracted by mini-css-extract-plugin
module.exports = {"title":"start-project-component_title__gowl1"};